import { IAppState } from '../../../../shared/common/state';
import { selectIsUserAgent } from './selectIsUserAgent';

export const selectIsProfessionalSearchPromoVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);

  return isAgent;
};
